module.exports = __webpack_public_path__ + "static/img/4_2.0e94b08.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/4_2.png
// module id = 7TE4
// module chunks = 2